module.exports = __webpack_public_path__ + "feasibility.a3d43c1ea07c748092cc04e47b03e52c.png";